/// <reference path="../../../../typings/globals/jquery/index.d.ts" />
/**
 * Obsługa skróconej wersji koszyka
 *
 * @export
 * @class SimpleCart
 * @extends {Clipboard}
 */
import { Clipboard } from "./Clipboard.class"

export class SimpleCart extends Clipboard {
	constructor() {
		super();
		this.isRefreshCartCounterTriggerd = false;
		this.cartCounterTimer = null;
		this.isActualSimpleCartContent = false;
		this.isSimpleCartContentTimer = null;
	}
	// ****************************************************************************************************
	// Inicjalizacja Koszyka
	// ****************************************************************************************************
	init() {
	}
	// ****************************************************************************************************
	// Odswieżanie licznika pozycji koszyka
	// ****************************************************************************************************
	refreshCartCounter(cartCounter) {
		var that = this;
		if ( !that.isRefreshCartCounterTriggerd ) {
			that.isRefreshCartCounterTriggerd = true;
			if ( cartCounter === undefined ) {
				toolsObj.ajaxLoadData({
					updateBrowserHistory: false,
					url: '/cart?getValue=cartCounter',
					target: '#cartBtn', // fakewe wskazanie na cel
					loadingMode: false,
					getDataMode: true,
					sourceOfError: 'SimpleCart::refreshCartCounter',
					onError: function () {
						//that.setCartCounter(0);
					},
					getData: function (data) {
						if ( data !== undefined ) {
							that.setCartCounter(Number(data));
							that.refreshCartCounterTimer();
						} else {
							//that.setCartCounter(0);
							loggerObj.addCustomError('Cart Counter data is undefined', 'SimpleCart::refreshCartCounter');
						}
					}
				});
			}
			else {
				that.setCartCounter(cartCounter);
				that.refreshCartCounterTimer();
			}
		}
		else {
			that.refreshCartCounterTimer();
		}
	}
	refreshCartCounterTimer() {
		var that = this;
		clearTimeout(that.cartCounterTimer);
		that.cartCounterTimer = setTimeout(function () {
			that.isRefreshCartCounterTriggerd = false;
		}, SIMPLE_CONTENT_LIFE_TIME);
	}
	setCartCounter(cartCounter) {
		(cartCounter > 0) ? $('.cartCounter').html(cartCounter).show() : $('.cartCounter').hide();
	}
	checkCartCounter() {
		var that = this;
		var cartPositionsCounter = Number($('#cartSimpleProductsList').data('size'));
		var actualCartCounterValue = Number($('#cartBtn .cartCounter').html());
		if (cartPositionsCounter != actualCartCounterValue) // zabezpieczenie przed wczytywaniem wcześniejszej wartości
			that.refreshCartCounter(cartPositionsCounter);
	}
	forceRefreshCartCounter(cartCounter) {
		var that = this;
		that.isRefreshCartCounterTriggerd = false;
		clearTimeout(that.cartCounterTimer);
		that.refreshCartCounter(cartCounter);
	}
	// ****************************************************************************************************
	// Ładowanie uproszczonego koszyka do popover
	// ****************************************************************************************************
	loadSimpleCartContent() {
		var that = this;
		var target = $('#cartSimpleContent, #' + $('#cartBtn').attr('aria-describedby') + ' .popover-body');
		if (!that.isActualSimpleCartContent) {
			that.isActualSimpleCartContent = true;
			$.ajax({
				url: '/cart?content=simple&current_action=ajax',
				processData: false, // fix for: Uncaught TypeError: Illegal invocation
				contentType: false, // fix for: Uncaught TypeError: Illegal invocation
				beforeSend: function () {
					target.html('<img class="d-block mx-auto align-self-center mw-100" src="/img/loading.gif" id="loadingGIF" />');
				},
				success: function (data) {
					target.html(data);
					that.loadSimpleCartContentTimer();
					that.checkCartCounter();
				}
			});
		}
		else {
			that.loadSimpleCartContentTimer();
		}
	}
	loadSimpleCartContentTimer() {
		var that = this;
		clearTimeout(that.isSimpleCartContentTimer);
		that.isSimpleCartContentTimer = setTimeout(function () {
			that.isActualSimpleCartContent = false;
		}, SIMPLE_CONTENT_LIFE_TIME);
	}
}